
import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import styles from "../styles/DashboardStyles/Dashboard.module.css";

import { DashboardOutlined, BookOutlined, ReadOutlined, GiftOutlined, DollarOutlined, CreditCardOutlined, TransactionOutlined, LineChartOutlined, TeamOutlined, FolderOutlined, ScheduleOutlined, FileTextOutlined, UsergroupAddOutlined, UserOutlined, AppstoreOutlined, QuestionCircleOutlined, HomeOutlined, GlobalOutlined, SettingOutlined, InfoCircleOutlined, PictureOutlined, StarOutlined, ReadFilled } from '@ant-design/icons';

import { useAuth } from "../provider/Auth.provider";
import SidebarRouting from "../components/FlowComponents/Sidebar/SidebarRouting";
import Header from "../Flows/SuperAdmin/Dashboard/Header";
import UserNotification from "../components/FlowComponents/userNotification/UserNotification";
import UserProfile from "../components/FlowComponents/userProfile/UserProfile";
import { findUserByUID } from "../service/findUsers/findUserByUID";
import { sampleNotificationData } from "../service/notificationService/sampleNotificationData";

const TrainerLayout = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [userData, setUserData] = useState({});
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      // Check if user or user.uid is not available
      if (!user || !user.uid) {
        navigate("/trainer/signin");
        return;
      }

      try {
        const userData = await findUserByUID(user.uid);
        // Check if userData exists and user_type is superAdmin
        if (!userData || userData.userTypes !== 'club_trainer') {
          navigate("/trainer/signin");
          return;
        } else {
          // Only redirect to dashboard if we're not already on a valid superadmin page
          const currentPath = window.location.pathname;
          if (currentPath === "/trainer" || currentPath === "/trainer/") {
            navigate("/trainer/dashboard", { replace: true });
          }
        }
        setUserData(userData);
      } catch (error) {
        console.error("Error fetching user data:", error);
        navigate("/trainer/signin");
      }
    };
    fetchUserData();
  }, [user, navigate]);

  useEffect(() => {
    const handleResize = () => {
      setIsMenuExpanded(false);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const menuItems = [
    { key: "dashboard", label: "Dashboard", icon: <ReadOutlined />, path: "/trainer/dashboard" },
    { key: "time", label:"Time", icon:<ScheduleOutlined /> , path:"/trainer/timesheet"}
    
  ];

  return (
    <div className={styles.dashboard}>
      <SidebarRouting
        menuItems={menuItems}
      />
      <div className={styles.maincontent}>
        <Header
          userData={userData}
        />
        <Outlet />
      </div>
    </div>
  );
};

export default TrainerLayout;
